import { CodeSystem } from "@intocare/datatypes/lib/code-system";

/**
 * The types of assessments supported by CareConnect.
 *
 * The codes correspond to the `name` of the reference `Questionnaire` resources shipped by `@intocare/assessments`,
 * while the display values correspond to their `title`. Note that assessments are mostly known by the name of the scale
 * they implement, which is why several display values are the same in both locales.
 */
export const ASSESSMENT_TYPE = {
	name: "ASSESSMENT_TYPE",
	concept: {
		BRADEN: {
			display: {
				"nl-BE": "Bradenschaal",
				"fr-BE": "Échelle de Braden",
			},
		},
		"DOLOPLUS-2": {
			display: {
				"nl-BE": "Doloplus-2",
				"fr-BE": "Doloplus-2",
			},
		},
		IDDSI: {
			display: {
				"nl-BE": "IDDSI",
				"fr-BE": "IDDSI",
			},
		},
		MMSE: {
			display: {
				"nl-BE": "Mini-Mental State Examination",
				"fr-BE": "MMSE",
			},
		},
		MNA: {
			display: {
				"nl-BE": "MNA schaal",
				"fr-BE": "MNA",
			},
		},
		NORTON: {
			display: {
				"nl-BE": "De Nortonschaal",
				"fr-BE": "Echelle de Norton",
			},
		},
		OHAT: {
			display: {
				"nl-BE": "OHAT schaal",
				"fr-BE": "Echelle de OHAT",
			},
		},
		"PACSLAC-D": {
			display: {
				"nl-BE": "PACSLAC-D",
				"fr-BE": "PACSLAC-D",
			},
		},
		PAINAD: {
			display: {
				"nl-BE": "PAINAD-schaal",
				"fr-BE": "Échelle de PAINAD",
			},
		},
		TIMED_CHAIR_STAND: {
			display: {
				"nl-BE": "Timed Chair Stand",
				"fr-BE": "Timed Chair Stand",
			},
		},
		TIMED_GET_UP_AND_GO: {
			display: {
				"nl-BE": "Timed Get Up and Go",
				"fr-BE": "Timed Get Up and Go",
			},
		},
		TINETTI: {
			display: {
				"nl-BE": "TINETTI Schaal",
				"fr-BE": "Échelle de TINETTI",
			},
		},
		VAS: {
			display: {
				"nl-BE": "VAS",
				"fr-BE": "VAS",
			},
		},
	},
} as const satisfies CodeSystem;
